export const getNow = () => {
  const dateTimeOverride = localStorage.getItem('dateTimeOverride');
  if (dateTimeOverride && process.env.ENVIRONMENT !== 'production') {
    return new Date(dateTimeOverride);
  }
  return new Date();
};
